module.exports = __webpack_public_path__ + "img/product-placeholder-55.3bcf863.png";